<template>
  <!-- 售后详情价格信息 -->
  <div class="price_con">
    <div class="price_item item_mr1">
      <div class="font12 font_weight400 colo087 line_height_18">退款金额</div>
      <div class="font14 font_weight600 colof00 line_height_16">
        {{ getAfterSaleInfo.returnPrice | currency(false) }}
      </div>
    </div>
    <div class="border_top1px price_item item_mr2" @click="goHistory">
      <div class="font12 font_weight400 colo087 line_height_24">协商历史</div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right_go"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getAfterSaleInfo() {
      return this.$store.getters.getAfterSaleInfo;
    }
  },
  methods: {
    goHistory() {
      this.$emit("goHistory", this.getAfterSaleInfo.id);
    }
  }
};
</script>

<style lang="less" scoped>
.price_con {
  margin-top: 12px;
  background: #fff;
  border-radius: 6px;
  padding: 0 12px;
  .right_go {
    width: 24px;
  }
  .price_item {
    display: flex;
    justify-content: space-between;
    .right_go {
      width: 24px;
    }
  }
  .item_mr1 {
    padding: 12px 0;
  }
  .item_mr2 {
    padding: 8px 0 9px;
  }
}
</style>
